import { z } from 'zod'

export const BRAND_ALIAS_MAX_LENGTH = 100

export const BRAND_ALIASES_DESCRIPTION =
  'Синонимы — другие написания этого бренда в файлах поставщиков и в поисковых запросах. Регистр, пробелы и дефисы не важны. Не добавляйте сюда другие бренды, даже родственные: остатки и поиск начнут их смешивать.'

export const brandAliasFormSchema = z.object({
  alias: z
    .string()
    .trim()
    .min(1, 'Введите синоним')
    .max(
      BRAND_ALIAS_MAX_LENGTH,
      `Синоним не длиннее ${BRAND_ALIAS_MAX_LENGTH} символов`
    ),
})

export type BrandAliasFormValues = z.infer<typeof brandAliasFormSchema>
